export const CANCEL_OFFER = 'Cancel offer';
export const RESEND_OFFER = 'Resend offer';
export const RESEND_OFFER_COMMENT = 'View rejection reason';
export const VIEW_ESTATE = 'View property profile';
export const PROPERTY = 'Property';
export const PAY_ESTATE = 'Pay';
export const BACKGROUND_CHECK_REQUEST = 'Background Check Request';
